import { Box, Title } from "@mantine/core";
import { useToast } from "../../../mantine/notifications/useToast";
import type { ExtendedUser } from "../../../utils/backend-types";
import { ProjectShareWidget } from "../../ProjectShareWidget/ProjectShareWidget";

interface RightsPageProps {
  projectId: string;
  projectName: string;
  projectManagers: Array<ExtendedUser>;
  onShare: (newManager: ExtendedUser) => void;
}

function RightsPage({
  projectId,
  projectName,
  projectManagers,
  onShare
}: RightsPageProps) {
  const { showErrorToast } = useToast();

  function handleError(error: unknown) {
    showErrorToast(error);
  }

  return (
    <Box className="RightsPage" maw={450}>
      <Title fw={500} order={5}>
        {projectName} teilen
      </Title>
      <ProjectShareWidget
        projectId={projectId}
        projectManagers={projectManagers}
        onError={handleError}
        onShare={onShare}
      />
    </Box>
  );
}

export { RightsPage };
